module.exports = __webpack_public_path__ + "make-difference-icon-7f391c621d2f954a5dc0195e139072b9.png";


/*****************
 ** WEBPACK FOOTER
 ** ../app/Components/Benefits/make-difference-icon.png
 ** module id = 476
 ** module chunks = 0
 **/